<div class="h-100 flex-grow-1">
  <!-- main-panel: paint the viewport the same as its rows so a hard scroll
       never reveals the darker page background behind unrendered rows. -->
  <cdk-virtual-scroll-viewport
    [itemSize]="rowSize"
    [minBufferPx]="minBufferPx"
    [maxBufferPx]="maxBufferPx"
    class="h-100 main-panel"
  >
    <div *cdkVirtualFor="let settlement of settlements; let i = index; trackBy: trackRow">
      <div
        (click)="select(settlement)"
        (keydown.enter)="select(settlement)"
        tabindex="0"
        role="button"
        [attr.data-test]="'settlement-item-' + i"
        class="main-panel stl-row d-flex flex-row align-items-center gap-3"
        [class.stl-row-empty]="settlement.grossAmount === 0"
        [class.interactive]="settlement.grossAmount !== 0"
      >
        <div class="stl-icon flex-shrink-0" [class.stl-icon-paid]="settlement.grossAmount !== 0">
          <mat-icon>savings</mat-icon>
        </div>

        <span
          data-test="transaction-created-date"
          class="stl-date flex-grow-1"
          >{{ settlement.settledDay | date: 'ccc, MMM dd, yyyy' }}</span
        >

        @if (settlement.grossAmount !== 0) {
          <div class="stl-amounts d-flex align-items-center justify-content-end">
            <div class="stl-amount d-none d-lg-flex">
              <span data-test="settlement-gross-title" class="stl-amount-label">Gross</span>
              <span data-test="settlement-gross" class="stl-amount-value">
                {{ settlement.grossAmount | currency: settlement.currencyCountry }}
              </span>
            </div>
            <div class="stl-amount stl-amount-fees d-none d-lg-flex">
              <span data-test="settlement-fees-title" class="stl-amount-label">Fees</span>
              <!-- Fees are rounded to 2dp for display; hover reveals the exact figure. -->
              <span
                data-test="settlement-fees"
                class="stl-amount-value stl-fees-exact"
                matTooltip="Exact fees: {{ settlement.totalFeeAmount | number: '1.6-6' }}"
                matTooltipPosition="above"
              >
                &minus;{{
                  settlement.totalFeeAmount
                    | currency: settlement.currencyCountry : 'symbol' : '1.2-2'
                }}
              </span>
            </div>
            <div class="stl-paid d-flex align-items-center gap-2">
              <mat-icon class="stl-paid-icon">check_circle</mat-icon>
              <div class="stl-amount">
                <span data-test="settlement-net-title" class="stl-amount-label">Paid</span>
                <span data-test="settlement-net" class="stl-amount-value stl-paid-value">
                  {{ settlement.netAmount | currency: settlement.currencyCountry }}
                </span>
              </div>
            </div>
          </div>
        } @else {
          <span class="stl-empty-msg text-end">
            <span class="d-none d-lg-inline">No statements have been processed for this day</span>
            <span class="d-inline d-lg-none">No statements</span>
          </span>
        }

        @if (allowSelection) {
          <mat-icon class="stl-chevron flex-shrink-0" [class.invisible]="settlement.grossAmount === 0"
            >chevron_right</mat-icon
          >
        }
      </div>
      <mat-divider></mat-divider>
    </div>
    <div>
      <ng-content></ng-content>
    </div>
  </cdk-virtual-scroll-viewport>
</div>
